import { USER_ROLE_CLUB } from '@/features/tasks/fanTasksAccess'
import { useHydratedAuthUi } from '@/lib/react/useHydratedAuthUi'
import { useAuthStore } from '@/stores/authStore'
import { getAuthTokenPayload } from '@/utils/auth'

export function useForClubsAudience() {
  const hasHydratedAuthUi = useHydratedAuthUi()
  const storeAuthenticated = useAuthStore(s => s.isAuthenticated)
  // Match SSR: authStore initializes as false on the server; reading the
  // client token on the first paint would change the Header nav (For Clubs
  // vs Tasks) and break hydration.
  const isAuthenticated = hasHydratedAuthUi ? storeAuthenticated : false
  const isClubUser =
    hasHydratedAuthUi &&
    Boolean(getAuthTokenPayload()?.roles?.includes(USER_ROLE_CLUB))
  const showClubOwnerExperience = isAuthenticated && isClubUser
  const isGuest = !isAuthenticated
  const isFan = isAuthenticated && !isClubUser

  return {
    isAuthenticated,
    isClubUser,
    showClubOwnerExperience,
    showForClubsNavLink: !isFan,
    isGuest
  }
}
